var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFLi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.979,
    height: 14.979,
    viewBox: "0 0 14.979 14.979",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Oval-1",
    d: "M14,17.846v9.9h3.207v-9.9ZM15.814,13a1.713,1.713,0,1,0-.042,3.421h.02A1.713,1.713,0,1,0,15.814,13Zm9.472,4.846A3.172,3.172,0,0,0,22.4,19.481v-1.4H19.189c.042.929,0,9.9,0,9.9H22.4V22.45a2.308,2.308,0,0,1,.106-.8,1.761,1.761,0,0,1,1.645-1.2c1.161,0,1.625.908,1.625,2.238v5.3h3.207V22.3C28.979,19.262,27.4,17.846,25.286,17.846Zm0,0",
    transform: "translate(-14 -13)",
    fill: "#312C40",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFLi);
export default __webpack_public_path__ + "static/media/f-li.b2aa5ef90089a300ab9d665b0d0829df.svg";
export { ForwardRef as ReactComponent };